import { useCallback } from 'react'
import { Toast } from 'antd-mobile'

import { store, handleCheckRewardsNoReceived, taskCompleteAtom, hasUnreadMessageAtom, userAtom } from '@/store'

import { EMessageType, IMessageContentExtra } from '@/types'
import { CommandDataMap } from 'react-provider'

export const useWebsocketHandlers = () => {
  const userInfo = store.get(userAtom)
  const handleSystemMessage = useCallback((payload: CommandDataMap['PUSH_MESSAGE']) => {
    const taskMessage =
      payload?.message_type === EMessageType.SystemMsg || payload?.message_type === EMessageType.newSystemMsg
        ? (payload?.message_content as unknown as IMessageContentExtra)
        : undefined

    if (!taskMessage) return

    if (Number(taskMessage.extra?.event?.type) === 1) {
      store.set(taskCompleteAtom, taskMessage)
    } else {
      Toast.show({
        position: 'top',
        maskClassName: 'task-tip',
        getContainer: document.getElementById('root'),
        content: taskMessage.content,
        duration: 3000,
      })
    }

    setTimeout(() => handleCheckRewardsNoReceived(), 200)
  }, [])

  const handleImMessage = useCallback((payload: CommandDataMap['PUSH_MESSAGE']) => {
    // 如果推送的消息是发送消息的响应，sender_id为自己的id，过滤
    if (userInfo.id === payload.sender_id || store.get(hasUnreadMessageAtom)) return
    store.set(hasUnreadMessageAtom, true)
  }, [])

  const handleOperation = useCallback(
    (payload: CommandDataMap['PUSH_MESSAGE']) => {
      handleSystemMessage(payload)
      handleImMessage(payload)
    },
    [handleSystemMessage, handleImMessage],
  )

  return { handleOperation }
}
